export default "__VITE_ASSET__DVfr4VJ3__"